<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col cols="12" v-if="!!getActiveCompany">
        <PageHeader
          title="Kérdéseim"
          :special-back-link="true"
          :enable-back-link="true"
          @goBack="returnToTasks"
        />
      </b-col>
    </b-row>
    <b-row class="font-poppins">
      <b-col cols="12">
        <b-card>
          <template v-slot:header>
            <b-container fluid>
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between">
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <div class="mb-0 custom-card-header-text">
                        Kérdéseim
                      </div>
                    </div>
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <b-button variant="success" @click="newTicket">
                        <i class="fas fa-plus mt-1"></i>
                        <span class="d-inline-block ml-2 mt-1">Új kérdés</span>
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </template>
          
          <TicketView
            :tickets="tickets.content"
            :apiLoading="apiLoadingTicket"
          />
          <paging 
            :item-per-page="tickets.itemPerPage"
            :total-rows="tickets.totalElements"
            @paging-change="doPage"
            ref="pageing"
          />
        </b-card>
      </b-col>
    </b-row>
    <new-ticket-modal 
    title="Új kérdés" 
    :show.sync="showNewTicketModal"
    :action="confirmUpdate"
    />
  </b-container>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client/index";
import { mapGetters } from "vuex";
import Paging from "../../../components/Paging.vue";
import TicketView from "../../../components/tickets/TicketView.vue";
import NewTicketModal from "../../../components/tickets/NewTicketModal.vue";

export default {
  name: "Tickets",
  components: {
    NewTicketModal,
    PageHeader,
    Paging,
    TicketView
},
  data() {
    return {
      apiLoadingTicket: true,
      tickets: [],
      showNewTicketModal: false
    };
  },
  methods: {
    returnToTasks() {
      let self = this;
      if (self.backRouterLink) {
        if (self.pageNumber) {
          self.$router.push({
            path: self.backRouterLink,
            query: {
              pageNumber: self.pageNumber,
              perPage: self.perPage,
            },
          });
        } else {
          self.$router.push(self.backRouterLink);
        }
      } else {
        self.$router.push("/app/home");
      }
    },
    newTicket() {
      this.showNewTicketModal = true;
    },
    hideTicketModal() {
      this.showNewTicketModal = false;
    },

    loadTickets(page, size) {
      this.apiLoadingTicket = true;
        Api.getTickets(page, size, this.getActiveCompany.id).then((resp) => {
          this.tickets = resp.data;
          this.apiLoadingTicket = false;

        })
    },
    doPage(data) {
      this.loadTickets(data.pagingPage - 1, data.pagingOffset);
    },
    
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  mounted() {
    this.loadTickets(0,5)
  },
  watch: {
    showNewTicketModal: function () {
      this.loadTickets(0,5)
    },

  },
};
</script>

<style scoped></style>
